import { useEffect } from 'react';
import { buildMypageProfilePath, navigate } from './api';

/** @deprecated /mypage/profile?tab=coin 으로 리다이렉트 */
export default function OneliveMobileMypageCoinHistoryPage() {
  useEffect(() => {
    navigate(buildMypageProfilePath('coin'));
  }, []);
  return null;
}
